<!-- <select name="select-timezone" id="select-timezone" class="{{classes}}"
        [ngModel]="selectedTimezone"
        (ngModelChange)="onSelectionChange($event)">
  <option *ngFor="let time of timezones" id="{{time.timezone}}" value="{{time.timezone}}">{{time.utcm | gmt}}
    {{time.timezone}}
  </option>
</select> -->

<mat-form-field style="width: 100%;" >
  <mat-select  floatLabel="never" placeholder="Time Zone" [(ngModel)] = "selectedTimezone" (ngModelChange)="onSelectionChange($event)">
    <mat-option *ngFor="let time of timezones" value = "{{time.timezone}}">
      {{time.utcm | gmt}} {{time.timezone}}
    </mat-option>
  </mat-select>
</mat-form-field>
